import React from "react";
import { renderToString } from "react-dom/server";
import { PinSvg } from "./PinSvg";

export type GroundTransportMapPinType = {
  type: "groundTransport";
  content: string;
}

export const getGroundTransportMapPin = (pin: GroundTransportMapPinType) => {
  const element = document.createElement("div");
  element.innerHTML = renderToString(<GroundTransportPin content={pin.content} />);
  return element;
}

interface GroundTransportPinProps {
  content: string;
}

export const GroundTransportPin = ({ content }: GroundTransportPinProps) => {
  return <div className="google-map-pin-wrapper">
    {content && <div className="google-map-pin-content google-map-pin-content-ground-transport">{content}</div>}
    <PinSvg width={27} height={43} empty={content === ""} fillColor="var(--map-ground-yellow)" />
  </div>
}